import { FC } from 'react';

// Utils
import { classNames } from '@sportal365/smp-widget-utils';

interface Props {
  value: string;
  index: number;
}

const DropdownSection: FC<Props> = ({ value, index }) => {
  return (
    <div
      className={classNames({
        'dropdown-section-container max-h-7 py-2 px-4 bg-primaryBackgroundColor': true,
        'rounded-t-4': index === 0,
      })}
    >
      <p className='dropdown-section-name m-0 text-primaryGray text-2 font-semibold whitespace-pre text-ellipsis overflow-hidden leading-[16px]'>
        {value}
      </p>
    </div>
  );
};

export default DropdownSection;
